import initializeForm from './initializeForm';
import openModal from './openModal';
import setIsNewRecord from './setIsNewRecord';

export default (filterData) => (dispatch) => {
    dispatch(initializeForm({ filterData }));
    dispatch(setIsNewRecord(true));
    dispatch(openModal(true));
};
